// extracted by mini-css-extract-plugin
export default {"markWrapper":"FacebookLogo_markWrapper__YEtVQ"};